import { Input } from '@cloudflare/kumo';

/** Campo de busca: `Input type="search"` com rótulo acessível e placeholder. */

export interface SearchFieldProps {
  value: string;
  /** Recebe o novo valor. */
  onChange: (value: string) => void;
  placeholder?: string;
  /** Rótulo acessível do campo. */
  ariaLabel?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  'data-testid'?: string;
}

export function SearchField({ value, onChange, placeholder, ariaLabel, autoFocus, disabled, ...rest }: SearchFieldProps) {
  return (
    <Input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
      placeholder={placeholder}
      autoFocus={autoFocus}
      disabled={disabled}
      {...rest}
    />
  );
}
